export default class Accordion {
  init(root) {
    this.root = root; // .accordion element
    this.items = root.querySelectorAll('.accordion-item');
    this.addEvents();
  }

  addEvents() {
    this.items.forEach((item, index) => {
      const header = item.querySelector('.accordion-header');
      const icon = item.querySelector('.accordion-icon');
      const content = item.querySelector('.accordion-content');

      console.log('Accordion item:', item);
      
      // Toggle accordion content visibility
      const toggleAccordion = () => {
        const isOpen = item.classList.contains('open');
        
        // Update the classes for open/closed states
        if (isOpen) {
          item.classList.remove('open');
          item.classList.add('closed');
        } else {
          item.classList.remove('closed');
          item.classList.add('open');
        }
        
        // Update ARIA attributes for accessibility
        const expanded = !isOpen;
        header.setAttribute('aria-expanded', expanded);
        content.setAttribute('aria-hidden', !expanded);
      };

      // Open/close on clicking header or icon
      header.addEventListener('click', toggleAccordion);
      icon.addEventListener('click', toggleAccordion);

      // Optionally, handle keyboard interactions for better accessibility
      header.addEventListener('keydown', (e) => {
        // Allow toggling with Enter or Space
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion();
        }
      });

      // Optionally, focus on the header when toggled
      header.addEventListener('click', () => {
        header.focus();
      });
    });
  }
}
